const slotsConfigLegacy = [
  // 20 x 20 perimeter ─────────
  {
    id: "A1",
    label: "A1",
    gridColumn: "8 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A2",
    label: "A2",
    gridColumn: "10 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A3",
    label: "A3",
    gridColumn: "12 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A4",
    label: "A4",
    gridColumn: "14/ span 2",
    gridRow: "2/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A5",
    label: "A5",
    gridColumn: "16 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A6",
    label: "A6",
    gridColumn: "18 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A7",
    label: "A7",
    gridColumn: "20 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A8",
    label: "A8",
    gridColumn: "22/ span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A9",
    label: "A9",
    gridColumn: "24/ span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
    {
    id: "A12",
    label: "A12",
    gridColumn: "26 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A10",
    label: "A10",
    gridColumn: "28 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },

  // Exit path
    {
    id: "Exit",
    label: "Exit",
    type: "blocker",
    gridColumn: "30 / span 2",
    gridRow: "1 span 1",
  },
  {
    id: "A11",
    label: "A11",
    gridColumn: "32/ span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A13",
    label: "A13",
    gridColumn: "34 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A14",
    label: "A14",
    gridColumn: "36 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A15",
    label: "A15",
    gridColumn: "38 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A16",
    label: "A16",
    gridColumn: "40 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A17",
    label: "A17",
    gridColumn: "42 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  },
  {
    id: "A18",
    label: "A18",
    gridColumn: "44 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  }
  ,
   {
    id: "Entry",
    label: "Entry",
    type: "blocker",
    gridColumn: "46/ span 2",
    gridRow: "1/ span 1",
  },
  {
    id: "A19",
    label: "A19",
    gridColumn: "48 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "down"
  }
  ,
  {
    id: "A20",
    label: "A20 ",
    gridColumn: "50 / span 2",
    gridRow: "4 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type:  "20x20",
    facing: "left"
  },
  {
    id: "A21",
    label: "A21 ",
    gridColumn: "52 / span 2",
    gridRow: " 6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type:  "20x20",
    facing: "left"

  },
   {
    id: "Gap",
    label: "Gap",
    type: "blocker",
    gridColumn: "54 / span 1",
    gridRow: "8/ span 2",
  },
  {
    id: "A22",
    label: "A22 ",
    gridColumn: "52 / span 2",
    gridRow: "10 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "left"
  },
  {
    id: "A23",
    label: "A23 ",
    gridColumn: "52 / span 2",
    gridRow: "12/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "left"
  },
  {
    id: "A24",
    label: "A24 ",
    gridColumn: "52 / span 2",
    gridRow: "14 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "left"
  },
  {
    id: "A25",
    label: "A25 ",
    gridColumn: "52 / span 2",
    gridRow: "16 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "left"
  },
  {
    id: "A26",
    label: "A26 ",
    gridColumn: "52 / span 2",
    gridRow: "18 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "left"
  },
  {
    id: "A27",
    label: "A27 ",
    gridColumn: "50 / span 2",
    gridRow: "20/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "top"
  },
   {
    id: "A28",
    label: "A28 ",
    gridColumn: "48/ span 2",
    gridRow: "22/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "top"
  },
   {
    id: "A29",
    label: "A29 ",
    gridColumn: "46 / span 2",
    gridRow: "24/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "top"
  },
   {
    id: "A30",
    label: "A30 ",
    gridColumn: "44 / span 2",
    gridRow: "24/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "top"
  },
   {
    id: "A31",
    label: "A31 ",
    gridColumn: "42 / span 2",
    gridRow: "24/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
   type: "20x20",
    facing: "top"
  },
   {
    id: "A32",
    label: "A32 ",
    gridColumn: "40 / span 2",
    gridRow: "24/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "top"
  },
   {
    id: "A33",
    label: "A33 ",
    gridColumn: "38 / span 2",
    gridRow: "24/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "top"
  },
  {
    id: "A34",
    label: "A34 ",
    gridColumn: "8 / span 2",
    gridRow: "22/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "right"
  },
  {
    id: "A35",
    label: "A35 ",
    gridColumn: "8 / span 2",
    gridRow: "20/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "right"
  },
    {
    id: "A36",
    label: "A36 ",
    gridColumn: "8 / span 2",
    gridRow: "18/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "right"
  },
  {
    id: "A37",
    label: "A37 ",
    gridColumn: "8 / span 2",
    gridRow: "14/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "right"
  },
  {
    id: "A38",
    label: "A38 ",
    gridColumn: "8 / span 2",
    gridRow: "8/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "right"
  },
  {
    id: "A39",
    label: "A39 ",
    gridColumn: "8 / span 2",
    gridRow: "6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20",
    facing: "right"
  },
  {
    id: "A40",
    label: "A40",
    gridColumn: "14 / span 2",
    gridRow: "6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
   {
    id: "A41",
    label: "A41",
    gridColumn: "14 / span 2",
    gridRow: "8/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
   {
    id: "A42",
    label: "A42",
    gridColumn: "14 / span 2",
    gridRow: "10/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  
   {
    id: "A44",
    label: "A44 ",
    gridColumn: "14 / span 2",
    gridRow: "12/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
     type: "20x20"
  },
  {
    id: "A45",
    label: "A45 ",
    gridColumn: "14 / span 2",
    gridRow: "18/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A46",
    label: "A46 ",
    gridColumn: "14 / span 2",
    gridRow: "20/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
     {
    id: "A47",
    label: "A47 ",
    gridColumn: "16 / span 2",
    gridRow: "6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
    {
    id: "A48",
    label: "A48 ",
    gridColumn: "16 / span 2",
    gridRow: "8/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
    {
    id: "A49",
    label: "A49 ",
    gridColumn: "16 / span 2",
    gridRow: "10/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
 
    {
    id: "A51",
    label: "A51 ",
    gridColumn: "16 / span 2",
    gridRow: "12/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
   {
    id: "A52",
    label: "A52 ",
    gridColumn: "16 / span 2",
    gridRow: "18/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A53",
    label: "A53 ",
    gridColumn: "16 / span 2",
    gridRow: "20/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },

  //pods 20x20 ─────────

  {
    id: "A54",
    label: "A54 ",
    gridColumn: "22 / span 2",
    gridRow: "21/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A55",
    label: "A55",
    gridColumn: "22 / span 2",
    gridRow: "18/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
   type: "17x17-pod"
  },
  {
    id: "A56",
    label: "A56",
    gridColumn: "22 / span 2",
    gridRow: "15/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A57",
    label: "A57",
    gridColumn: "22 / span 2",
    gridRow: "12/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A58",
    label: "A58 ",
    gridColumn: "22 / span 2",
    gridRow: "9/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A59",
    label: "A59",
    gridColumn: "22 / span 2",
    gridRow: "6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A60",
    label: "A60",
    gridColumn: "26 / span 2",
    gridRow: "6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A61",
    label: "A61 ",
    gridColumn: "30 / span 2",
    gridRow: "6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A62",
    label: "A62 ",
    gridColumn: "34 / span 2",
    gridRow: "6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A63",
    label: "A63",
    gridColumn: "34 / span 2",
    gridRow: "9/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A64",
    label: "A64 ",
    gridColumn: "34 / span 2",
    gridRow: "12/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A65",
    label: "A65 ",
    gridColumn: "34 / span 2",
    gridRow: "15/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A66",
    label: "A66 ",
    gridColumn: "34 / span 2",
    gridRow: "18/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "A67",
    label: "A67",
    gridColumn: "34 / span 2",
    gridRow: "21/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "B68",
    label: "B68",
    gridColumn: "26 / span 2",
    gridRow: "10/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type:"17x17-pod"
  },
  {
    id: "B69",
    label: "B69",
    gridColumn: "26 / span 1",
    gridRow: "17/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B70",
    label: "B70",
    gridColumn: "26 / span 1",
    gridRow: "18/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B71",
    label: "B71 ",
    gridColumn: "26 / span 1",
    gridRow: "20/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B72",
    label: "B72 ",
    gridColumn: "26 / span 1",
    gridRow: "21/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  
  
  {
    id: "B73",
    label: "B73 ",
    gridColumn: "30 / span 2",
    gridRow: "10/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "17x17-pod"
  },
  {
    id: "B74",
    label: "B74 ",
    gridColumn: "27 / span 1",
    gridRow: "17/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B79",
    label: "B79 ",
    gridColumn: "30 / span 1",
    gridRow: "17/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B80",
    label: "B80 ",
    gridColumn: "30 / span 1",
    gridRow: "18/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
   {
    id: "B81",
    label: "B81 ",
    gridColumn: "30 / span 1",
    gridRow: "20/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
   {
    id: "B83",
    label: "B83 ",
    gridColumn: "31 / span 1",
    gridRow: "17 / span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  
  {
    id: "B84",
    label: "B84 ",
    gridColumn: "31 / span 1",
    gridRow: "18 / span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
    {
    id: "B85",
    label: "B85 ",
    gridColumn: "31 / span 1",
    gridRow: "20 / span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B38",
    label: "B86 ",
    gridColumn: "31 / span 1",
    gridRow: "21 / span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  
   {
    id: "B82",
    label: "B82 ",
    gridColumn: "30 / span 1",
    gridRow: "21/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B75",
    label: "B75 ",
    gridColumn: "27 / span 1",
    gridRow: "18/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B76",
    label: "B76 ",
    gridColumn: "27 / span 1",
    gridRow: "20/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
    {
    id: "B28",
    label: "B78 ",
    gridColumn: "27 / span 1",
    gridRow: "21/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  
  {
    id: "A78",
    label: "A78 ",
    gridColumn: "40 / span 2",
    gridRow: "8/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
   
  {
    id: "A79",
    label: "A79 ",
    gridColumn: "40 / span 2",
    gridRow: "10/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A80",
    label: "A80 ",
    gridColumn: "40 / span 2",
    gridRow: "12/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A81",
    label: "A81 ",
    gridColumn: "40 / span 2",
    gridRow: "16/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A82",
    label: "A82 ",
    gridColumn: "40 / span 2",
    gridRow: "18/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A83",
    label: "A83 ",
    gridColumn: "42 / span 2",
    gridRow: "8/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A88",
    label: "A88 ",
    gridColumn: "46 / span 2",
    gridRow: "10/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "space"
  },
  {
    id: "A89",
    label: "A89 ",
    gridColumn: "46 / span 2",
    gridRow: "16/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A84",
    label: "A84 ",
    gridColumn: "42 / span 2",
    gridRow: "10/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A85",
    label: "A85 ",
    gridColumn: "42 / span 2",
    gridRow: "12/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A86",
    label: "A86 ",
    gridColumn: "42 / span 2",
    gridRow: "16/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  {
    id: "A87",
    label: "A87 ",
    gridColumn: "42 / span 2",
    gridRow: "18/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },

  //------podium-------//

  {
    id:"P0",
    label:"PODIUM",
    gridColumn:"16/ span 20",
    gridRow:"27 /span 3"

  },

  //------------ 10x10-single----------//
{
  id:"B1",
  label:"B1",
  gridColumn: "34 / span 1",
  gridRow: "25/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B2",
  label:"B2",
  gridColumn: "28 / span 1",
  gridRow: "26/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B3",
  label:"B3",
  gridColumn: "27 / span 1",
  gridRow: "26/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B4",
  label:"B4",
  gridColumn: "26 / span 1",
  gridRow: "26/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B5",
  label:"B5",
  gridColumn: "25 / span 1",
  gridRow: "26/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B6",
  label:"B6",
  gridColumn: "24 / span 1",
  gridRow: "26/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B7",
  label:"B7",
  gridColumn: "23 / span 1",
  gridRow: "26/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B11",
  label:"B11",
  gridColumn: "15 / span 1",
  gridRow: "22/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B12",
  label:"B12",
  gridColumn: "16 / span 1",
  gridRow: "22/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B13",
  label:"B13",
  gridColumn: "17 / span 1",
  gridRow: "22/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B18",
  label:"B18",
  gridColumn: "40 / span 1",
  gridRow: "20/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B19",
  label:"B19",
  gridColumn: "41 / span 1",
  gridRow: "20/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B21",
  label:"B21",
  gridColumn: "42 / span 1",
  gridRow: "20/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
{
  id:"B22",
  label:"B22",
  gridColumn: "43 / span 1",
  gridRow: "20/ span 1",
  width: 1,
  height: 1,
  capacity: 1,
  type: "10x10-single"

},
  {
    id: "B31",
    label: "B31",
    gridColumn: "7 / span 1",
    gridRow: "26/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },
  {
    id: "B32",
    label: "B32",
    gridColumn: "8 / span 1",
    gridRow: "26/ span 1",
    width: 1,
    height: 1,
    capacity: 1,
    type: "10x10-single"
  },

  // ───────── LARGE SHARED STALL (4 VENDORS) ─────────
  {
    id: "C2",
    label: "C2 ",
    gridColumn: "6 / span 2",
    gridRow: "22/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C3",
    label: "C3 ",
    gridColumn: "6 / span 2",
    gridRow: "19/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C4",
    label: "C4 ",
    gridColumn: "6 / span 2",
    gridRow: "14/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  
  {
    id: "C6",
    label: "C5 ",
    gridColumn: "4 / span 2",
    gridRow: "6/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C7",
    label: "C6 ",
    gridColumn: "1 / span 2",
    gridRow: "7/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C8",
    label: "C7 ",
    gridColumn: "1 / span 2",
    gridRow: "9/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C9",
    label: "C8 ",
    gridColumn: "1 / span 2",
    gridRow: "11/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C10",
    label: "C9 ",
    gridColumn: "1 / span 2",
    gridRow: "13/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C11",
    label: "C10 ",
    gridColumn: "1 / span 2",
    gridRow: "15/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C12",
    label: "C11 ",
    gridColumn: "1 / span 2",
    gridRow: "17/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C13",
    label: "C12 ",
    gridColumn: "1 / span 2",
    gridRow: "21/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court"
  },
  {
    id: "C14",
    label: "C13",
    gridColumn: "5 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court",
    
  },  
  {
    id: "C15",
    label: "C14",
    gridColumn: "3/ span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court",
    
  },
    {
    id: "C16",
    label: "C15",
    gridColumn: "1 / span 2",
    gridRow: "2 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court",
    
  },
  {
    id: "C17",
    label: "C16",
    gridColumn: "1 / span 2",
    gridRow: "5 / span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "Food Court",
    
  },
  {
    id: "D1",
    label: "D1 ",
    gridColumn: "9 / span 2",
    gridRow: "25/ span 2",
    width: 1,
    height: 1,
    capacity: 1,
    type: "20x20"
  },
  //path components//
  {
    id: "z1",
    label: "KIJANI STREET ",
    gridColumn: "8 / span 42",
    gridRow: "4 / span 2",
    
    type: "pathway"
  },
  {
    id: "z2",
    label: " SAMAWATI STREET ",
    gridColumn: "49 / span 1",
    gridRow: "6 / span 15",
    
    type: "pathway"
  },
  {
    id: "z3",
    label: "KIJIVU STREET ",
    gridColumn: "11 / span 37",
    gridRow: "23 / span 1",
    
    type: "pathway"
  },
  {
    id: "z4",
    label: "PERA LANE ",
    gridColumn: "28 / span 2",
    gridRow: "5 / span 18",
    
    type: "pathway"
  },
  {
    id: "z5",
    label: "EMBE LANE ",
    gridColumn: "24 / span 2",
    gridRow: "5 / span 18",
    
    type: "pathway"
  },
  {
    id: "z6",
    label: "ZABIBU LANE ",
    gridColumn: "19 / span 2",
    gridRow: "5 / span 18",
    
    type: "pathway"
  },
   {
    id: "z7",
    label: "CHUNGWA LANE ",
    gridColumn: "32 / span 2",
    gridRow: "5 / span 18",
    
    type: "pathway"
  },
  {
    id: "z8",
    label: "LIMAU  LANE",
    gridColumn: "37 / span 2",
    gridRow: "5 / span 18",
    
    type: "pathway"
  },
  {
    id: "z9",
    label: "TUNDA LANE",
    gridColumn: "11 / span 2",
    gridRow: "5 / span 18",
    
    type: "pathway"
  },
  
  //open slots//
  {
    id:"O1",
    label:"O1",
    gridColumn: "28 / span 1",
    gridRow: "1 / span 1",
    type:"space"
  },
   {
    id:"O2",
    label:"O2",
    gridColumn: "6 / span 1",
    gridRow: "10/ span 1",
    type:"space"
  },
  {
    id:"O3",
    label:"O3",
    gridColumn: "41 / span 1",
    gridRow: "6/ span 1",
    type:"space"
  },
  {
    id:"O4",
    label:"O4",
    gridColumn: "8 / span 1",
    gridRow: "10/ span 1",
    type:"space"
  },
  {
    id:"O5",
    label:"O5",
    gridColumn: "8 / span 1",
    gridRow: "13/ span 1",
    type:"space"
  },






]

export default slotsConfigLegacy;
